import withAemIntegration from "../../../withAemIntegration";

const ComponentEditConfig = {
  emptyLabel: "Service History",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const ServiceHistory = (props) => {
  return <div></div>;
};

export default withAemIntegration("lexus/components/drivers/service-history")(
  ServiceHistory,
  ComponentEditConfig
);
